// Dashboard page: KPI strip, both charts and the "needs attention" list.
//
// Key = the exact English source string used in the code. Value = German.
// Do NOT redefine keys already in common.ts.

export const dashboard: Record<string, string> = {
  'Loading data …': 'Daten werden geladen …',

  // Empty state (no invoices yet)
  'Import data': 'Daten importieren',
  'Refresh from database': 'Aus Datenbank neu laden',

  // Filters
  'All years': 'Alle Jahre',
  'Legal entity': 'Gesellschaft',
  'All entities': 'Alle Gesellschaften',
  'Different file': 'Andere Datei',
  '{n} invoices from the uploaded file.': '{n} Rechnungen aus der hochgeladenen Datei.',

  // Due-date banner
  'due within 7 days': 'fällig in den nächsten 7 Tagen',

  // KPI strip
  'Key figures': 'Kennzahlen',
  Outstanding: 'Offen',
  unpaid: 'unbezahlt',
  'Due soon (7d)': 'Bald fällig (7 T)',
  'due soon': 'bald fällig',
  'Approved for payment': 'Zur Zahlung freigegeben',
  Pending: 'In Bearbeitung',
  'Open + in review': 'Offen + in Prüfung',
  'Total net': 'Netto gesamt',
  'Total gross': 'Brutto gesamt',
  'Total records': 'Datensätze gesamt',
  'Unique suppliers': 'Verschiedene Lieferanten',
  'VAT amount': 'Umsatzsteuerbetrag',
  'Tax-free amount': 'Steuerfreier Betrag',

  // Charts
  'Monthly gross volume': 'Bruttovolumen pro Monat',
  'booked invoices': 'gebuchte Rechnungen',
  'Top suppliers': 'Top-Lieferanten',
  'Share of gross spend': 'Anteil an den Bruttoausgaben',

  // Needs-attention list
  'Needs attention': 'Zu prüfen',
  'View all in Database': 'Alle in der Datenbank ansehen',
  'Nothing needs attention — no overdue, due-soon, or in-review invoices.':
    'Nichts zu prüfen — keine überfälligen, bald fälligen oder in Prüfung stehenden Rechnungen.',
  '{n} days overdue': '{n} Tage überfällig',
  'in {n} days': 'in {n} Tagen',
  'more — see Database': 'weitere — siehe Datenbank',

  // ExcelImport (only reachable from the dashboard's empty state)
  'Import {what}': '{what} importieren',
  'Drag an Excel file here': 'Excel-Datei hierher ziehen',
  'or click to browse': 'oder klicken zum Auswählen',
  'Processing file …': 'Datei wird verarbeitet …',
  'Click here to upload a different file': 'Klicke hier, um eine andere Datei hochzuladen',
  '{n} invoices loaded': '{n} Rechnungen geladen',
  '{n} invoices imported successfully': '{n} Rechnungen erfolgreich importiert',
  'Required columns:': 'Erforderliche Spalten:',
  'The Excel file contains no sheets': 'Die Excel-Datei enthält keine Tabellenblätter',
  'No invoices found in the file. Please check the column names.':
    'Keine Rechnungen in der Datei gefunden. Bitte prüfe die Spaltennamen.',
  'Could not read the file': 'Die Datei konnte nicht gelesen werden',
  'Please upload an Excel file (.xlsx, .xls)': 'Bitte eine Excel-Datei (.xlsx, .xls) hochladen',
}
